// SEO 관련 상수 정의

export const SEO_CONFIG = {
  // 사이트 기본 정보
  SITE_NAME: '에코딜(EcoDeal)',
  SITE_URL: 'https://ecodeal.kr',
  
  // 기본 메타태그
  DEFAULT_TITLE: '에코딜(EcoDeal) - 마감할인 40-50% | 음식물 쓰레기 줄이기 | 못난이 식품 할인',
  DEFAULT_DESCRIPTION: '마감 임박 음식 40-50% 할인! 김밥, 도시락, 샐러드, 베이커리 마감세일. 1인가구 혼밥 할인, 남은 음식 판매, 재고 떨이, 유통기한 임박 상품. 서울, 경기, 인천 지역 음식점 마감할인 플랫폼',
  
  // Open Graph 기본값
  OG_IMAGE: '/og-image.jpg',
  OG_TYPE: 'website',
  
  // Twitter Card 기본값
  TWITTER_CARD_TYPE: 'summary_large_image' as const,
};

export const SEO_KEYWORDS = {
  // 브랜드 키워드
  BRAND: [
    '에코딜',
    'ecodeal',
    '에코 딜',
    'eco deal',
  ],
  
  // 핵심 서비스 키워드
  SERVICE: [
    '마감할인',
    '마감세일',
    '땡처리',
    '떨이',
    '재고처분',
    '예약할인',
    '예약구매',
    '사전예약 할인',
    '40프로 할인',
    '50프로 할인',
    '반값 할인',
  ],
  
  // 음식 카테고리 키워드
  FOOD: [
    '김밥 할인',
    '도시락 할인',
    '샐러드 할인',
    '베이커리 할인',
    '카페 마감할인',
    '분식 마감할인',
    '한식 마감할인',
    '치킨 할인',
    '피자 할인',
    '햄버거 할인',
  ],
  
  // 타겟 고객 키워드
  TARGET: [
    '1인가구 할인',
    '혼밥 할인',
    '자취생 할인',
    '직장인 점심 할인',
    '저녁 할인',
    '야식 할인',
  ],
  
  // 환경/사회적 가치 키워드
  ENVIRONMENT: [
    '음식물쓰레기줄이기',
    '푸드테크',
    '친환경소비',
    '못난이식품',
    '못난이농산물',
    '잉여식품',
    '음식낭비방지',
    '제로웨이스트',
    '지속가능한소비',
  ],
  
  // 경쟁 서비스 대체재 키워드
  COMPETITOR: [
    '라스트오더 대체',
    '굿투고 대체',
    '어글리어스 대체',
  ],
  
  // 지역 키워드
  LOCATION: [
    '서울 마감할인',
    '강남 마감할인',
    '홍대 마감할인',
    '경기도 마감할인',
    '인천 마감할인',
  ],
};

// 키워드 조합 함수
export const combineKeywords = (...keywordGroups: string[][]): string[] => {
  return keywordGroups.flat();
};

// 전체 키워드 세트
export const ALL_KEYWORDS = combineKeywords(
  SEO_KEYWORDS.BRAND,
  SEO_KEYWORDS.SERVICE,
  SEO_KEYWORDS.FOOD,
  SEO_KEYWORDS.TARGET,
  SEO_KEYWORDS.ENVIRONMENT,
  SEO_KEYWORDS.COMPETITOR,
  SEO_KEYWORDS.LOCATION
);

// Schema.org 구조화 데이터 템플릿
export const SCHEMA_TEMPLATES = {
  // Organization 스키마
  ORGANIZATION: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '에코딜(EcoDeal)',
    alternateName: ['EcoDeal', '에코 딜', 'eco deal'],
    url: 'https://ecodeal.kr',
    logo: 'https://ecodeal.kr/logo.png',
    description: '음식물 쓰레기를 줄이고 40-50% 할인받는 친환경 플랫폼',
    foundingDate: '2024',
    keywords: 'ำ감할인, 음식할인, 친환경소비, 푸드테크',
    slogan: '지구를 지키며 절약하는 똑똑한 소비',
    knowsAbout: ['음식물쓰레기감소', '마감할인', '지속가능한소비'],
    sameAs: [
      'https://www.instagram.com/ecodeal_kr',
      'https://www.facebook.com/ecodeal.kr',
      'https://blog.naver.com/ecodeal',
    ],
  },
  
  // WebApplication 스키마
  WEB_APPLICATION: {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: '에코딜',
    operatingSystem: 'Any',
    applicationCategory: 'FoodApplication',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'KRW',
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.5',
      ratingCount: '1000',
    },
  },
  
  // LocalBusiness 스키마 (매장용)
  LOCAL_BUSINESS: (store: any) => ({
    '@context': 'https://schema.org',
    '@type': 'Restaurant',
    name: store.name,
    address: {
      '@type': 'PostalAddress',
      addressLocality: store.city,
      addressRegion: store.region,
      streetAddress: store.street_address,
    },
    servesCuisine: store.cuisine_type,
    priceRange: '₩₩',
    acceptsReservations: 'true',
    menu: store.menu_url,
  }),
  
  // Product 스키마 (상품용)
  PRODUCT: (product: any, store: any) => ({
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    image: product.image_url,
    description: product.description,
    offers: {
      '@type': 'Offer',
      price: product.discounted_price,
      priceCurrency: 'KRW',
      priceValidUntil: product.valid_until,
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Restaurant',
        name: store.name,
      },
    },
  }),
};